exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/**\n * React Starter Kit (https://www.reactstarterkit.com/)\n *\n * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE.txt file in the root directory of this source tree.\n */\n._2C6Mb {\n  text-align: center; }\n.BRVBn {\n  margin-bottom: 0; }\n", ""]);

// Exports
exports.locals = {
	"empty": "_2C6Mb",
	"mb0": "BRVBn"
};